module.exports = __webpack_public_path__ + "03_short_gold.8a06a4eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_short_gold.png
// module id = 8WEL
// module chunks = 0